var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BaseModal",
        {
          attrs: {
            bus: _vm.busModal,
            "button-title": "Abrir",
            height: "600px",
            "max-width": "90%",
            persistent: ""
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [
                  _c("SectionTitle", {
                    attrs: {
                      title: "Cadastro de clientes",
                      subtitle: "Adicionar clientes na sua base"
                    }
                  })
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "cadastro-cliente" }, [
            _c("div", { staticClass: "cadastro-cliente__container" }, [
              _c(
                "div",
                { staticClass: "cadastro-cliente__card az-card-consolidator" },
                [
                  _c("span", { staticClass: "text-heading-medium" }, [
                    _vm._v(" Novo cliente ")
                  ]),
                  _c("span", { staticClass: "text-sm" }, [
                    _vm._v(" Cadastre seus novos clientes ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "cadastro-cliente__card-actions" },
                    [
                      _c(
                        "BaseButton",
                        {
                          staticClass: "cadastro-cliente__card-button",
                          attrs: { primary: "" },
                          on: { click: _vm.openNewClientForm }
                        },
                        [_vm._v(" Novo Cliente ")]
                      ),
                      _c(
                        "BaseButton",
                        {
                          staticClass: "cadastro-cliente__card-button",
                          attrs: { primary: "" },
                          on: { click: _vm.openModalCarteiraAdministrada }
                        },
                        [_vm._v(" Carteira Administrada ")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "cadastro-cliente__card az-card-consolidator" },
                [
                  _c("span", { staticClass: "text-heading-medium" }, [
                    _vm._v(" Lista de clientes ")
                  ]),
                  _c("span", { staticClass: "text-sm" }, [
                    _vm._v(" Importe seus clientes")
                  ]),
                  _c(
                    "div",
                    { staticClass: "cadastro-cliente__card-actions" },
                    [
                      _c(
                        "BaseButton",
                        {
                          staticClass: "cadastro-cliente__card-button",
                          attrs: { primary: "", outline: "", small: "" },
                          on: { click: _vm.dowloadFile }
                        },
                        [
                          _c("icon-svg", {
                            attrs: {
                              color: "primary",
                              name: "document-download"
                            }
                          }),
                          _vm._v(" Baixar Modelo ")
                        ],
                        1
                      ),
                      _c(
                        "BaseModal",
                        {
                          attrs: {
                            bus: _vm.busSecond,
                            height: "650px",
                            "max-width": "1200px",
                            persistent: ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "button",
                              fn: function() {
                                return [
                                  _c(
                                    "BaseButton",
                                    {
                                      staticClass:
                                        "cadastro-cliente__card-button",
                                      attrs: { primary: "" }
                                    },
                                    [_vm._v(" Importar Clientes ")]
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "actions",
                              fn: function(ref) {
                                var close = ref.close
                                return [
                                  _c(
                                    "BaseButton",
                                    {
                                      attrs: { underlined: "" },
                                      on: { click: close }
                                    },
                                    [_vm._v("Cancelar")]
                                  ),
                                  _c(
                                    "BaseButton",
                                    {
                                      attrs: {
                                        loading: _vm.loading,
                                        disabled: !_vm.is_valid,
                                        primary: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.importClients(close)
                                        }
                                      }
                                    },
                                    [_vm._v(" Salvar ")]
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("SectionTitle", {
                                attrs: {
                                  subtitle: "Cadastrar clientes em lote",
                                  title: "Importar clientes"
                                }
                              }),
                              _c("div", { staticClass: "uploadBox" }, [
                                _c("div", { staticClass: "uploadBoxMain" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropArea",
                                      class: _vm.dragging
                                        ? "dropAreaDragging"
                                        : "",
                                      staticStyle: { position: "relative" },
                                      on: {
                                        dragend: function($event) {
                                          _vm.dragging = false
                                        },
                                        dragenter: function($event) {
                                          _vm.dragging = true
                                        },
                                        dragleave: function($event) {
                                          _vm.dragging = false
                                        },
                                        dragover: function($event) {
                                          $event.preventDefault()
                                        },
                                        drop: function($event) {
                                          $event.preventDefault()
                                          return _vm.onChange($event)
                                        }
                                      }
                                    },
                                    [
                                      _c("div", [
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.file_name
                                                ? _vm.file_name
                                                : "Importe seu CSV"
                                            )
                                          )
                                        ]),
                                        _c("input", {
                                          attrs: {
                                            id: "file",
                                            accept:
                                              ".xls,.xlsx,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                            name: "file",
                                            required: "",
                                            type: "file"
                                          },
                                          on: { change: _vm.onChange }
                                        }),
                                        _c("p", { staticClass: "help-block" }, [
                                          _vm._v(
                                            " Arraste o arquivo que deseja fazer o upload ou clique para adicioná-lo "
                                          )
                                        ])
                                      ])
                                    ]
                                  )
                                ])
                              ]),
                              Object.keys(_vm.html || {}).length
                                ? _c(
                                    "div",
                                    {
                                      style: {
                                        "align-items": "center",
                                        "justify-content": "center",
                                        "margin-top": "10px"
                                      }
                                    },
                                    [
                                      _c("TabelaPlanilha", {
                                        staticClass: "table-new-ux",
                                        attrs: {
                                          widthTable: "100%",
                                          data: _vm.html,
                                          _id: "tabela-conferir-novos-clientes"
                                        }
                                      }),
                                      _vm._l(_vm.errors, function(i, idx) {
                                        return _c(
                                          "div",
                                          {
                                            key: "e" + idx,
                                            style: { "margin-top": "20px" }
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                style: {
                                                  "font-size": "14px",
                                                  color: "red"
                                                }
                                              },
                                              [_vm._v(_vm._s(i.toString()))]
                                            )
                                          ]
                                        )
                                      }),
                                      _vm._l(_vm.warnings, function(i, idx) {
                                        return _c(
                                          "div",
                                          {
                                            key: "w" + idx,
                                            style: { "margin-top": "20px" }
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "text-warning",
                                                style: {
                                                  "font-size": "14px",
                                                  "font-weight": "bold"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(i.toString()) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _c(
        "BaseModal",
        {
          attrs: {
            bus: _vm.busNewClient,
            height: "800px",
            "max-width": "70%",
            persistent: ""
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [
                  _c("SectionTitle", {
                    attrs: {
                      subtitle: "Cadastre o cliente",
                      title: "Novo cliente"
                    }
                  })
                ]
              },
              proxy: true
            },
            {
              key: "actions",
              fn: function(ref) {
                var close = ref.close
                return [
                  _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: close } },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "BaseButton",
                    {
                      attrs: {
                        loading: _vm.loadingNovo,
                        primary: "",
                        "data-tour": "cp-novo-cliente-salvar"
                      },
                      on: {
                        click: function($event) {
                          return _vm.newClient(close)
                        }
                      }
                    },
                    [_vm._v(" Cadastrar cliente ")]
                  )
                ]
              }
            }
          ])
        },
        [
          _c(
            "div",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "cadastro-cliente__form",
                  attrs: { "data-tour": "cp-novo-cliente-form" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  },
                  model: {
                    value: _vm.formValid,
                    callback: function($$v) {
                      _vm.formValid = $$v
                    },
                    expression: "formValid"
                  }
                },
                [
                  _c("ClientFields", {
                    key: _vm.clientFieldsResetKey,
                    attrs: {
                      mode: "create",
                      "profile-items": _vm.perfis,
                      "profile-loading":
                        _vm.$store.getters["portfolio/portfolioModelsLoading"],
                      "professional-items": _vm.assessores,
                      "show-broker-code-tooltip": "",
                      "show-partnership-hint": _vm.$store.getters[
                        "parameters/canShow"
                      ]("partnership"),
                      "responsible-return-object": "",
                      "client-data": _vm.clientData
                    },
                    on: {
                      "update:clientData": function($event) {
                        _vm.clientData = $event
                      },
                      "update:client-data": function($event) {
                        _vm.clientData = $event
                      }
                    }
                  }),
                  _c("div", { staticClass: "text-secondary text-xs mt-5" }, [
                    _vm._v(" * Campos obrigatórios ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("div", {
            staticStyle: {
              "border-top": "1px solid #8e8e8e80",
              "margin-block": "16px"
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }